import React, { useState } from "react";

import {
    View,
    Text,
    TouchableOpacity,
    Image,
    ViewStyle,
    TextStyle,
    Platform,
    ActivityIndicator
} from "react-native";
import Style from "../../utils/Style";
import SVGView from "../../utils/SvgView";
import AppTheme from "../../utils/Theme";
import * as Constants from "../../utils/Constants";

import { default as IcSelected } from "../../assets/svg/icons/solid/check.svg";
import { default as IcFilter } from "../../assets/svg/lili/ic_filter.svg";
import Images from "../../../specific/utils/Images";
import { EventRegister } from "../../utils/EventListeners";
import { addFilterToUser, addLevelToUser } from "../../services/Firebase/Database";
import User from "../../data/user/User";
import Modal, { LiliModalProps } from "../../../specific/components/Modal/Modal";

interface UserLevelSelectionProps extends LiliModalProps {
    toggleFilters: () => void;
    backgroundColor?: string;
}

const UserLevelSelection = (props: UserLevelSelectionProps) => {

    const appTheme: AppTheme = new AppTheme();
    const images: Images = new Images();
    const user: User = User.getInstance();

    const { toggleFilters, backgroundColor = appTheme.daySkyColor, ...restProps } = props;

    const [selectedLevel, setSelectedLevel] = useState<string | undefined>(user.children_level);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const filterToggled = (id_level: string) => {
        setSelectedLevel(id_level);
    }

    const viewWidth = ((Platform.OS === "web") && (appTheme.getFlexDirectionForSplitScreen() === "row")) ? 734 : appTheme.getFullAppWidth() - appTheme.pixelPerfect(20);
    const answerWidth = ((Platform.OS === "web") && (appTheme.getFlexDirectionForSplitScreen() === "row")) ? 530 : viewWidth - appTheme.pixelPerfect(20);
    const selectionButtonWidth = (answerWidth - appTheme.pixelPerfect(5)) / 2;
    const userTypeColor: string = user.profile === "family" ? appTheme.homeColor : appTheme.schoolColor;
    const userTypeTextColor: string = user.profile === "family" ? appTheme.darkBlue : appTheme.white;
    const mainBackgroundColor = appTheme.white;
    const titleTextColor = backgroundColor;
    const buttonBackgroundColor = mainBackgroundColor;
    const buttonTextColor = titleTextColor;

    const buttonStyle: ViewStyle = {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: buttonBackgroundColor,
        borderWidth: appTheme.pixelPerfect(0.5),
        borderColor: userTypeColor + "AA",
        minHeight: appTheme.pixelPerfect(42),
        width: answerWidth,
        borderRadius: appTheme.pixelPerfect(20),
        marginBottom: appTheme.pixelPerfect(10)
    }

    const buttonTextStyle: TextStyle = {
        fontFamily: appTheme.primarySemiBoldFont,
        fontSize: appTheme.pixelPerfectForFont(10),
        color: user.profile === "family" ? appTheme.darkBlue : userTypeColor,
        textAlign: "center"
    }

    const validationButtonStyle: ViewStyle = {
        ...buttonStyle,
        borderWidth: 0,
        width: selectionButtonWidth
    }

    const reversedValidationButtonStyle: ViewStyle = {
        ...validationButtonStyle,
        backgroundColor: userTypeColor
    }

    const reversedButtonTextStyle: TextStyle = {
        ...buttonTextStyle,
        color: userTypeTextColor
    }

    const onValidateFilters = async () => {
        setIsLoading(true);
        const user: User = User.getInstance();
        // On va les enregistrer dans la base de données
        if (selectedLevel !== undefined) {
            await addLevelToUser({ user_id: user.uid, level: selectedLevel });
            user.children_level = selectedLevel;
            user.filter_by_level = [selectedLevel];
            EventRegister.emitEvent(Constants.EventFiltersByLevelChanged, {});
            toggleFilters();
        }
        setIsLoading(false);
    }

    const getFilters = () => {
        let filtersChoices = [];
        for (const aFilterKey in Constants.filtres) {
            if (Object.prototype.hasOwnProperty.call(Constants.filtres, aFilterKey)) {
                const aFilterName = Constants.levels[aFilterKey];
                const imageForFilter = aFilterKey === "cycle1" ? images.illStepFilterForAge46 : aFilterKey === "cycle2" ? images.illStepFilterForAge69 : images.illStepFilterForAge912;
                const backgroundColorForButton = selectedLevel === aFilterKey ? userTypeColor : appTheme.white;
                const textColorForButton = user.profile === "family" ? appTheme.darkBlue : selectedLevel === aFilterKey ? appTheme.white : userTypeColor;
                filtersChoices.push(<TouchableOpacity key={aFilterKey} onPress={() => filterToggled(aFilterKey)} style={[buttonStyle, { paddingHorizontal: appTheme.pixelPerfect(2), justifyContent: "flex-start", flexDirection: "row", backgroundColor: backgroundColorForButton }]}>
                    <Image source={imageForFilter} style={{ width: appTheme.pixelPerfect(34), height: appTheme.pixelPerfect(34), borderRadius: appTheme.pixelPerfect(18) }} />
                    <Text style={[buttonTextStyle, { flex: 1, paddingEnd: appTheme.pixelPerfect(20), color: textColorForButton }]}>{aFilterName}</Text>
                    <View style={{ position: "absolute", right: appTheme.pixelPerfect(10), opacity: selectedLevel === aFilterKey ? 1 : 0 }}>
                        <SVGView Component={IcSelected} size={18} color={textColorForButton} />
                    </View>
                </TouchableOpacity>);
            }
        }
        return filtersChoices;
    }

    const renderButtonContent = () => {
        if (isLoading === false) {
            return <Text style={reversedButtonTextStyle}>{"Valider"}</Text>
        }
        return <ActivityIndicator color={"#FFFFFF"} />
    }

    const justifyContent = "center";
    return (<Modal
        transparent={true}
        animationType="fade"
        {...restProps}>
        <View style={{ width: "100%", height: "100%", justifyContent, alignItems: "center", backgroundColor: backgroundColor + "40" }}>
            <View style={[{ paddingTop: appTheme.pixelPerfect(40) }]}>
                <View style={[Style.shadowed, { backgroundColor: mainBackgroundColor, width: viewWidth, minHeight: appTheme.pixelPerfect(100), borderRadius: appTheme.pixelPerfect(20), alignItems: "center", paddingBottom: appTheme.bottomInsets }]}>
                    <View style={[{ marginTop: -appTheme.pixelPerfect(40), marginBottom: appTheme.pixelPerfect(20), paddingHorizontal: appTheme.pixelPerfect(10), alignItems: "center", justifyContent: "center" }]}>
                        <View style={{ width: appTheme.pixelPerfect(80), height: appTheme.pixelPerfect(80), backgroundColor: appTheme.white, overflow: "hidden", borderWidth: appTheme.pixelPerfect(2), borderColor: appTheme.white, justifyContent: "center", alignItems: "center", borderRadius: appTheme.pixelPerfect(40) }}>
                            <View style={{ width: appTheme.pixelPerfect(72), height: appTheme.pixelPerfect(72), borderRadius: appTheme.pixelPerfect(36), backgroundColor: userTypeColor, justifyContent: "center", alignItems: "center" }}>
                                <SVGView Component={IcFilter} color={appTheme.white} size={42} />
                            </View>
                        </View>
                    </View>
                    <Text style={{ paddingHorizontal: appTheme.pixelPerfect(20), textAlign: "center", fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(10), color: titleTextColor, textTransform: "uppercase" }}>
                        {"Choisir le niveau"}
                    </Text>
                    <View style={{ marginVertical: appTheme.pixelPerfect(20) }}>
                        {getFilters()}
                    </View>
                    <View style={{ marginVertical: appTheme.pixelPerfect(10), flexDirection: "row", justifyContent: "center", width: answerWidth }}>
                        <TouchableOpacity disabled={isLoading} onPress={() => onValidateFilters()} style={[reversedValidationButtonStyle]}>
                            {renderButtonContent()}
                        </TouchableOpacity>
                    </View>
                </View>
            </View>
        </View>
    </Modal>)
}

export default UserLevelSelection;